<template>
  <div>
    <div class="text-center">
      <v-calendar
        class="custom-calendar max-w-full"
        :masks="masks"
        :attributes="attributes"
        disable-page-swipe
        is-expanded
        @update:to-page="changePage"
        :min-date="new Date()"
        :firstDayOfWeek="1"
        :disabled-dates="{ weekdays: [1, 7] }"
      >
        <template v-slot:day-content="{ day, attributes }">
          <div style="min-height: 90px;" class="flex flex-col h-full z-10 overflow-hidden">
            <span class="day-label text-sm text-gray-900">{{ day.day }}</span>
            <div class="flex-grow overflow-y-auto overflow-x-auto">
              <ul v-if="todayOrFutureDate(day.id)" style="line-height: 110%; margin-top: -14px;">
                <li v-for="(attr, index) in attributes" :key="attr.key" >
                  <span v-if="index < 4">{{ attr.customData.title }}</span>
                  <span v-if="index === 4">
                    <el-popover
                      placement="top-start"
                      width="200"
                      trigger="hover">
                      <ul style="margin: 0 0 0 -8px;">
                        <li v-for="att in attributes">{{ att.customData.title }}</li>
                      </ul>
                      <div slot="reference">more &hellip; </div>
                    </el-popover>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </template>
      </v-calendar>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data'],
  data() {
    return {
      masks: {
        weekdays: 'WWW',
      },
      attributes: [],
      currentPage: {
        month: new Date().getMonth(),
        year: new Date().getFullYear()
      }
    }
  },
  methods: {
    todayOrFutureDate(dayId) {
      const calendarDate = new Date(dayId)
      const now = new Date()
      const yesterday = now.setDate(now.getDate() -1)
      return calendarDate > yesterday
    },
    changePage(page) {
      this.currentPage = page
      this.$store.commit('users/daysOffAllUsers', this.currentPage)
      this.attributes = []
      this.attributes = this.$store.get('users/daysOffByMonthAndYearAllUsers', this.currentPage)
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="postcss" scoped>
::-webkit-scrollbar {
  width: 0;
}

::-webkit-scrollbar-track {
  display: none;
}

/deep/ .custom-calendar.vc-container {
  --day-border: 1px solid #b8c2cc;
  --day-border-highlight: 1px solid #b8c2cc;
  --day-width: 90px;
  --day-height: 90px;
  --weekday-bg: #f8fafc;
  --weekday-border: 1px solid #eaeaea;

  border-radius: 0;
  width: 100%;

& .vc-header {
    background-color: #f1f5f8;
    padding: 10px 0;
  }
& .vc-weeks {
    padding: 0;
  }
& .vc-weekday {
    background-color: var(--weekday-bg);
    border-bottom: var(--weekday-border);
    border-top: var(--weekday-border);
    padding: 5px 0;
  }
& .vc-day {
    padding: 0 5px 3px 5px;
    text-align: left;
    height: var(--day-height);
    min-width: var(--day-width);
    background-color: white;
&.weekday-1,
&.weekday-7 {
   background-color: #eff8ff;
 }
&:not(.on-bottom) {
   border-bottom: var(--day-border);
&.weekday-1 {
   border-bottom: var(--day-border-highlight);
 }
}
&:not(.on-right) {
   border-right: var(--day-border);
 }
}
& .vc-day-dots {
    margin-bottom: 5px;
  }
}
</style>
